export const AcceptableUsePolicy = () => {
  return (
    <div className="policy-container" style={{ backgroundColor: 'white', height: '100vh', width: '100%' }}>
      <iframe
        src="https://app.termly.io/policy-viewer/policy.html?policyUUID=68af7bb0-caa8-4e96-b6c8-192fc638dd40"
        title="Acceptable Use Policy"
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
      />
    </div>
  );
}; 